

import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export default function SpaBooking({ spaId }) {
  const demoBookings = [
    {
      guestName: 'Sokha Chan',
      treatment: 'Swedish Massage',
      time: '2025-08-06 14:00',
      status: 'Confirmed'
    },
    {
      guestName: 'David Lee',
      treatment: 'Facial Rejuvenation',
      time: '2025-08-06 16:00',
      status: 'Pending'
    }
  ];

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Spa Bookings
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Guest Name</TableCell>
              <TableCell>Treatment</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {demoBookings.map((booking, index) => (
              <TableRow key={index}>
                <TableCell>{booking.guestName}</TableCell>
                <TableCell>{booking.treatment}</TableCell>
                <TableCell>{booking.time}</TableCell>
                <TableCell>{booking.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}